<template>
  <div>
    <h2 id="post-heading" class="tipslista__antalresultat">
      Resultat: <span>{{ totalCount }} {{ totalCount === 1 ? 'träff' : 'träffar' }}</span>
    </h2>
    <ul v-if="totalCount > 0" class="tipslista__lista">
      <li
        v-for="item in items"
        :key="item.Id"
        :data-id="item.Id"
        class="tipslista__kort HittaTipsSidaKort"
        :class="{ highlight: item.MarkeratTips }"
      >
        <HittaTipsSidaKort
          :tips="item"
          :show-share="true"
          :is-share-open="sharedTipId === item.Id"
          :is-copied="copiedTipId === item.Id"
          @toggle-share="toggleShare(item.Id)"
          @copy-url="copyUrl(item)"
        />
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, onUnmounted, PropType, ref } from 'vue';
import HittaTipsSidaKort from './HittaTipsSidaKort.vue';
import { TipsItemDto } from './hittaTipsSidaService';

export default defineComponent({
  name: 'TipsList',
  components: { HittaTipsSidaKort },
  props: {
    items: { type: Array as PropType<TipsItemDto[]>, required: true },
    totalCount: { type: Number, required: true },
  },
  setup() {
    const sharedTipId = ref<number | null>(null);
    const copiedTipId = ref<number | null>(null);

    function toggleShare(id: number) {
      sharedTipId.value = sharedTipId.value === id ? null : id;
      copiedTipId.value = null;
    }

    async function copyUrl(item: TipsItemDto) {
      try {
        await navigator.clipboard.writeText(item.DelningsUrl);
        copiedTipId.value = item.Id;
      } catch {
        console.error('Failed to copy URL to clipboard');
      }
    }

    function closeShare() {
      sharedTipId.value = null;
      copiedTipId.value = null;
    }

    onMounted(() => {
      document.addEventListener('click', closeShare);
    });

    onUnmounted(() => {
      document.removeEventListener('click', closeShare);
    });

    return {
      sharedTipId,
      copiedTipId,
      toggleShare,
      copyUrl,
    };
  }
});
</script>
